import toast from './toast'

export default function beforeRouteLeave(to, from, next) {
  if (to.path === '/auth/callback') {
    if (window.WebViewJavascriptBridge) {
      window.WebViewJavascriptBridge.callHandler('exit')
    } else {
      toast('在真机环境下此时已退出网页')
    }
    next(false)
    return
  }
  next()
}



// WEBPACK FOOTER //
// ./src/utils/before-route-leave.js